const areas = [
  {
    title: "AI Infrastructure",
    body: "The control planes, governance, and cost layers enterprises need before AI fleets go to production.",
  },
  {
    title: "Sovereign AI",
    body: "Customer-owned, in-tenancy systems for markets and boardrooms that can't accept a walled garden.",
  },
  {
    title: "Physical AI",
    body: "Intelligence moving into devices and the real world.",
  },
];

const Thesis = () => {
  return (
    <section className="py-32 px-4 bg-primary text-primary-foreground">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-16 space-y-6">
          <div className="inline-block px-6 py-3 bg-accent/10 border-2 border-accent/30 rounded">
            <span className="text-sm font-bold tracking-[0.3em] text-accent uppercase">Thesis</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black leading-tight text-primary-foreground">
            Where we invest
          </h2>
        </div>

        <div className="space-y-8">
          {areas.map((area) => (
            <div
              key={area.title}
              className="space-y-3 border-l-4 border-accent pl-6 py-4 hover:border-primary-foreground transition-colors"
            >
              <h3 className="text-2xl font-black tracking-wide text-primary-foreground">{area.title}</h3>
              <p className="text-lg text-primary-foreground/90 leading-relaxed max-w-3xl">{area.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Thesis;